import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showOnboarding: {
    shop: true,
    qore: true,
    audit: true,
    studio: true,
    dataset: true,
    project: true,
    billing: true,
    chatbot: true,
    settings: true,
    dashboard: true,
    labelcraft: true,
    competition: true,
    quickPredikt: true,
    chatbotDetail: true,
    projectDetail: true,
  }
}

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setOnboarding: (state, action) => {
      state.showOnboarding[action.payload.page] = false;
    }
  }
})

export const { setOnboarding } = appSlice.actions;

export const selectOnboardingTour = (state) => state.app.showOnboarding